type LinkType = "main" | "clients" | "franchise" | "internal" | "external";

export function resolveLegacyLink(
  link?: string,
  linkType: LinkType = "main"
) {
  if (!link) return "#";

  // Si déjà absolu → on ne touche pas
  if (link.startsWith("http")) return link;

  switch (linkType) {
    case "clients":
      return `${process.env.NEXT_PUBLIC_SITE_CLIENTS}${link}`;

    case "franchise":
      return `${process.env.NEXT_PUBLIC_SITE_FRANCHISE}${link}`;

    case "internal":
      return link; 

    case "external":
      return link;

    case "main":
    default:
      return `${process.env.NEXT_PUBLIC_SITE_PUBLIC}${link}`;
  }
}
